import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpModule } from "@angular/http";
import { NgSharedModule } from "../ng-shared/ng-shared.module";
import { NgAppCpuMemoryStatsComponent } from "./ng-app-cpu-memory-stats/ng-app-cpu-memory-stats.component";
/**
 * This modules holds the reusable common components and services for monitoring
 */
@NgModule({
    imports: [
        CommonModule,
        HttpModule,
        NgSharedModule
    ],
    declarations: [
        NgAppCpuMemoryStatsComponent
    ],
    exports: [
        NgAppCpuMemoryStatsComponent
    ]
})
export class NgAppMonitoringModule {
    constructor() {
    }
}
